import * as React from "react";
import { Button, Container, Loader, Modal } from "semantic-ui-react";

import { ReviewHealthSurveillanceResultsModel } from "@teamprevent/common/healthSurveillance/models";

import { healthSurveillanceReviewApi } from "../healthSurveillanceReviewApi";

import { ReviewHealthSurveillanceOutcome } from "./ReviewHealthSurveillanceOutcome";

interface OwnProps {
    customerId: string;
    ohCaseId: string;
    onClose: () => void;
}

const ReadonlyHealthSurveillanceReviewForm: React.FunctionComponent<OwnProps> = (props: OwnProps) => {

    const [model, setModel] = React.useState<ReviewHealthSurveillanceResultsModel | null>(null);

    React.useEffect(() => {
        (async () => {
            const results = await healthSurveillanceReviewApi.getReviewHealthSurveillanceResults(props.customerId, props.ohCaseId);
            setModel(results);
        })();
    }, []);

    if (!model) {
        return <Loader active />;
    }

    return (
        <>
            <Modal.Content>
                <Container>
                    {model?.outcomes?.map((outcome, i) => <ReviewHealthSurveillanceOutcome key={i} medicalOutcome={outcome} />)}
                </Container>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Close" onClick={props.onClose} />
            </Modal.Actions>
        </>
    );
};

export { ReadonlyHealthSurveillanceReviewForm };
